
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3f65e92a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./main.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./main.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3f65e92a\"}!../../../../vue-loader/lib/selector?type=template&index=0!./main.vue"),
  /* scopeId */
  "data-v-3f65e92a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/steps/main.vue
// module id = 1423
// module chunks = 124